import { animate, AnimationEvent, state, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

type ExpandedPanelButton = 'close' | 'collapse';

@Component({
  selector: 'expanded-panel',
  templateUrl: './expanded-panel.component.html',
  styleUrls: ['./expanded-panel.component.scss'],
  animations: [
    trigger('slideInOut', [
      state('open', style({ transform: 'translateX(0)' })),
      state('closed', style({ transform: 'translateX(100%)' })),
      transition('void => open', [
        style({ transform: 'translateX(100%)' }),
        animate('300ms ease-out', style({ transform: 'translateX(0)' }))
      ]),
      transition('closed => open', [animate('300ms ease-out')]),
      transition('open => closed', [animate('300ms ease-in')])
    ])
  ]
})
export class ExpandedPanelComponent implements OnChanges {
  @Input() open: boolean | null = null;
  @Output() closed = new EventEmitter<void>();
  @Output() closedAll = new EventEmitter<void>();
  expanded = true;

  buttonsClicked: Record<ExpandedPanelButton, boolean> = {
    close: false,
    collapse: false
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['open'] && this.open !== null) {
      this.expanded = this.open;
    }
  }

  onButtonClicked(button: ExpandedPanelButton) {
    this.expanded = false;
    this.buttonsClicked[button] = true;
  }

  onAnimDone(e: AnimationEvent): void {
    if (e.toState === 'closed') {
      if (this.buttonsClicked.collapse) this.closed.emit();
      else if (this.buttonsClicked.close) this.closedAll.emit();
      this.buttonsClicked = { close: false, collapse: false };
    }
  }
}
